import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import PaymentsGrid from '../../organisms/Payments';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flex: 1
  }
}));

const Payments = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <PaymentsGrid></PaymentsGrid>
    </div>
  );
}

export default Payments;